module.exports = __webpack_public_path__ + "static/media/dkv-logo.324b8d5c.svg";